import { DatePicker, FormLabel, Heading } from "@/components";
import usePayment360Report from "./useAR360Report";
import { DetailedReport } from "./DetailedReport";
import { PropertyReport } from "./PropertyReport";
import { Button } from "@/components/ui";
import { cn, ROLE_BOM } from "@/lib/utils";

const AR360Report = () => {
  const {
    breadcrumbData,
    setDate,
    date,
    isPropertyView,
    onBackClick,
    togglePropertyView,
    currentRole,
    currentFinanceYear
  } = usePayment360Report();

  return (
    <div className="p-4 md:p-6">
      {/* Header & Search */}
      <div className="flex flex-col xl:flex-row gap-2 xl:items-center xl:justify-between mb-6 sticky top-[55px] z-10 bg-g-10 pb-3">
        <div className="flex flex-row items-center justify-between">
          <Heading
            title={<span>Collection 360 Report <span className="text-[12px]">(FY-{currentFinanceYear})</span></span>}
            breadcrumbData={breadcrumbData}
            showBack
            onBackClick={onBackClick}
          />
        </div>
        <div
          className={cn(
            "grid grid-cols-1 gap-[30px] items-center",
            currentRole == ROLE_BOM ? "md:grid-cols-2" : "md:grid-cols-1"
          )}
        >
          <Button onClick={togglePropertyView} className="md:w-[300px]">
            {isPropertyView
              ? "View Detailed Report"
              : "View Detailed Report By Property"}
          </Button>
          <div className="relative w-auto lg:w-[300px]">
            <FormLabel>Date</FormLabel>
            <DatePicker
              setDate={setDate}
              date={date}
              onClear={() => setDate(null)}
            />
          </div>
        </div>
      </div>

      {/* Data section */}
      {isPropertyView ? (
        <PropertyReport reportDate={date} />
      ) : (
        <DetailedReport reportDate={date} />
      )}
    </div>
  );
};

export default AR360Report;
